import { Directive, HostListener } from "@angular/core";

@Directive({
	selector: "input[obgNoWhitespaceInput]",
})
export class NoWhitespaceInputDirective {
	@HostListener("input", ["$event"]) onInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		input.value = input.value.replace(/\s/g, "");
	}
}
